import { render, staticRenderFns } from "./tit-tertiary.vue?vue&type=template&id=6cb57e2e&scoped=true"
import script from "./tit-tertiary.vue?vue&type=script&lang=js"
export * from "./tit-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb57e2e",
  null
  
)

export default component.exports